module.exports = __webpack_public_path__ + "img/home.c96c1132.png";